/* src/app/modules/fiscalidad/fiscal.component.css */
mat-sidenav-container {
  margin: 0;
  width: 100%;
  height: 100%;
  height: calc(100% - 64px);
}
.convfact-core-content {
  margin: 15px;
}
.mat-icon {
  margin: auto 10px;
  color: var(--cf-brand-dark);
}
.spacer {
  flex: 1 1 auto;
}
.icon {
  padding: 0 14px;
}
.input {
  direction: rtl;
}
/*# sourceMappingURL=fiscal.component.css.map */
